import { d as deprecated } from './6cf04c83.mjs';
import { c as clone, e as extend, a as isEmptyObject, i as isPlainObject } from './085c42f3.mjs';
import { c as coerce, d as deserialize, s as serialize, a as serializeForm } from './26bb3b6f.mjs';

function toArray(object) {
  deprecated("o_util.core.toArray", "use native Array.from instead");
  const array = [];
  for (let i = object.length - 1; i >= 0; i -= 1) {
    array[i] = object[i];
  }
  return array;
}
function removeFromArray(originalArray, from, to) {
  const rest = originalArray.slice((to || from) + 1 || originalArray.length);
  originalArray.length = from < 0 ? originalArray.length + from : from;
  originalArray.push.apply(originalArray, rest);
  return originalArray;
}

function bind(fnThis, fn) {
  deprecated("o_util.core.bind", "use native bind instead");
  return (...args) => fn.apply(fnThis, args);
}
function convertStringToFunction(functionName, context) {
  const namespaces = functionName.split(".");
  const func = namespaces.pop();
  let part = context;
  for (let i = 0, len = namespaces.length; i < len; i += 1) {
    part = part[namespaces[i]];
  }
  return part[func];
}

function cloneFunction(functionReference) {
  deprecated("o_util.core.cloneFunction", "this is dangerous, do not use");
  let key;
  if (typeof functionReference !== "function") {
    return functionReference;
  }
  function temp() {
    return functionReference.apply(null, arguments);
  }
  for (key in functionReference) {
    if (functionReference.hasOwnProperty(key)) {
      temp[key] = functionReference[key];
    }
  }
  return temp;
}

var index = /*         */Object.freeze({
  __proto__: null,
  bind: bind,
  clone: clone,
  cloneFunction: cloneFunction,
  coerce: coerce,
  convertStringToFunction: convertStringToFunction,
  deserialize: deserialize,
  extend: extend,
  isEmptyObject: isEmptyObject,
  isPlainObject: isPlainObject,
  removeFromArray: removeFromArray,
  serialize: serialize,
  serializeForm: serializeForm,
  toArray: toArray
});

export { cloneFunction as a, bind as b, convertStringToFunction as c, index as i, removeFromArray as r, toArray as t };
/*                                 */
